import React from 'react';
import { ITableItem } from '../RssFeed/RssFeed';
import styles from './RssFeedItem.module.css';
import { FontIcon } from '@fluentui/react/lib/Icon';
import Strings from '../../../translations/strings';

interface IRssFeedItemProps {
    item: ITableItem;
}

const RssFeedItem = ({ item }: IRssFeedItemProps) => {
    return (
        <div className={styles.itemRow}>
            <div className={styles.itemImgWrap}>
                <img className={styles.itemImg} src={item.img} alt={item.title} />
            </div>
            <div className={styles.itemContent}>
                <div className={styles.itemTitle}>{item.title}</div>
                <div className={styles.itemSubtitle}>
                    <span className={styles.itemCreator}>{item.creator}</span>|
                    <span className={styles.itemPubDate}>{item.pubDate}</span>|
                    <span className={styles.itemCategory}>{item.category}</span>
                </div>

                <div className={styles.itemDescription}>{item.description}</div>
                <div className={styles.itemLinkWrap}>
                    <a href={item.link} target="_blank" rel="noreferrer noopener" className={styles.itemLink}>
                        <span>{Strings.components.rssFeed.articleLink}</span>
                        <FontIcon iconName="Forward" className={styles.forwardIcon} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default RssFeedItem;
